import React from 'react';
import  { useState,   useCallback,
    useMemo,
    useRef,
  
    StrictMode, } from 'react';
import  { useEffect }from 'react';
import './DnevnepromjeneDonat.css'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { componentStyles } from '../services/elementDesign'
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';



import Fab from '@mui/material/Fab';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';


import Grid from '@mui/material/Unstable_Grid2';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Modal from '@mui/material/Modal';


import Loader3 from './Loader3';
import { DataGrid,
    useGridApiRef,
    DEFAULT_GRID_AUTOSIZE_OPTIONS,} from '@mui/x-data-grid';
import axios from 'axios';
import { APICall } from './services/api.service';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from "./redux/actions"
import AutoModal from './AutoModal';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {statusObradeOptions, trebaLiSklonitiOptions} from './variables/variables.js';

import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import Swal from 'sweetalert2';
import { Alert } from '@mui/material';

import * as useLocalStorage from './services/useLocalStorage'
import BijeleStranice from './BijeleStranice.js';
import ZuteStranice from './ZuteStranice.js';

import ExportCSV from './ExportCSV';

//import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";



import { AllCommunityModule } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";

import { Autocomplete} from '@mui/material';

import {
    ClientSideRowModelModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    ModuleRegistry,
    ValidationModule,
    createGrid,
    themeQuartz,
    themeBalham,


    RowSelectionModule,


  } from "ag-grid-community";
import { AiOutlineConsoleSql } from 'react-icons/ai';
import { DiDart } from 'react-icons/di';
  


import { RowApiModule } from 'ag-grid-community'; 



  ModuleRegistry.registerModules([
    RowSelectionModule,
    ClientSideRowModelModule,


    ValidationModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    RowApiModule
   
  ]);



  const myTheme = themeBalham.withParams({
    headerHeight: "30px",
    headerTextColor: "black",
    headerBackgroundColor: "#99ABCD",
    headerCellHoverBackgroundColor: "rgba(80, 40, 140, 0.66)",
    headerCellMovingBackgroundColor: "rgb(80, 40, 140)",
    //selectedRowBackgroundColor: 'rgba(0, 255, 0, 0.1)',
    selectedRowBackgroundColor: '#8386a6'
  });
  






const theme = createTheme({
    palette: {
        primary: {
            main: '#520074'
        }
    },
    mixins: {
        MuiDataGrid: {
          // Pinned columns sections
          pinnedBackground: '#520074',
          // Headers, and top & bottom fixed rows
          containerBackground: 'primary',
        },
      },

});




function AdminDaily() {

    const gridRef = useRef();
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);




    const autoSizeStrategy = useMemo(() => {
        return {
          type: "fitGridWidth",
          defaultMinWidth: 100
        };
      }, []);

      const autoSizeAll = useCallback((skipHeader) => {
        const allColumnIds = [];
        gridRef.current.api.getColumns().forEach((column) => {
          allColumnIds.push(column.getId());
        });
        gridRef.current.api.autoSizeColumns(allColumnIds, skipHeader);
      }, []);


      const onGridReady = useCallback((event) => {
        console.log("Grid ready *********************************************************************************")
        let nodes = event.api.getRenderedNodes();
        autoSizeAll();
        if (nodes.length) {
          //nodes[0].setSelected(true); //selects the first row in the rendered view
          //nodes[1].setSelected(true);
        }
      }, []);

      const selectAll = useCallback((event) =>{

            event.api.selectAll();
           
      }, []);

      const onColumnResized = useCallback((params) => {
      }, []);

      const themeAG = useMemo(() => {
        return myTheme;
      }, []);
    
      const onRowSelected = useCallback((event) => {

      }, []);


    
      const onSelectionChanged = useCallback((event) => {
        const rowCount = event.api.getSelectedNodes().length;
        let items=[]
        let itemsTelefon=[]


        for(var i=0; i<event.api.getSelectedNodes().length; i++) {


            items.push(event.api.getSelectedNodes()[i].data);

        }
        
 
        setSelectedItemsUsers(items);
     
     
      
      }, []);



     const cellClicked = useCallback(async (cell)=>{

   
               
                console.log(cell);

                console.log(cell.data)

                setSeeStatRef(cell.data.val_daily_stat_ref==0?false:true);
                setSeeStatTK(cell.data.val_daily_stat_tk==0?false:true);
                setSeeStatRefAll(cell.data.val_daily_stat_all_ref==0?false:true);

                setSeeDaily(cell.data.val_daily_view==0?false:true);

                setEditDaily(cell.data.val_daily_edit==0?false:true);

                setAdminData(cell.data.val_daily_data_admin==0?false:true);

                setAdminTK(cell.data.val_daily_tk_admin==0?false:true);

                setAdminUsers(cell.data.val_daily_admin==0?false:true);

                setValIme(cell.data.val_name);

                setValUsername(cell.data.val_username);

                setValID(cell.data.val_id);
             
                              

     })


 

/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/*************************************STATE VARIJABLE**************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */


    const [filteredTableData, setFilteredTableData] = useState([],[])
   
    
    const [filters, setFilters] = useState([false, false, false, false, false, false, false, false, false])


    const [selectedItemsUsers, setSelectedItemsUsers] = useState([]);


    
    const dispatch = useDispatch()

    const navigate = useNavigate();

    const [curr_time, setCurrTime] = useState('');


    const token = localStorage.getItem("token");


    //const { user: currentUser } = useSelector((state) => state.auth);
    const user = localStorage.getItem("user");
    const username = localStorage.getItem("username");
    const ref = localStorage.getItem("id");


    const [admin, setAdmin] = useState(false);
    const [seeDaily, setSeeDaily] = useState(false);
    const [editDaily, setEditDaily] = useState(false);
    const [seeStatRef, setSeeStatRef] = useState(false);
    const [seeStatRefAll, setSeeStatRefAll] = useState(false);
    const [seeStatTK, setSeeStatTK] = useState(false);
    const [adminTK, setAdminTK] = useState(false);
    const [adminData, setAdminData] = useState(false);
    const [adminUsers, setAdminUsers] = useState(false);

    




    const [val_ime, setValIme] = useState('');
    const [val_username, setValUsername] = useState('');

    const [valID, setValID] = useState('');

 

    const [tkList, setTkList] = useState([10, 11, 35, 40, 42, 44, 45, 49, 50, 60, 63, 66, 68, 88, 99, 999]);



    const [bureInfo, setBureInfo] = useState('');

    const [telefon, setTelefon] = useState('');
    const [OIB, setOIB] = useState('');
    const [obrnuto, setObrnuto] = useState('');
    const [telefon2, setTelefon2] = useState('');
    const [OIB2, setOIB2] = useState('');
    const [obrnuto2, setObrnuto2] = useState('');



    const [naziv1, setNaziv1] = useState('');
    const [naziv2, setNaziv2] = useState('');
    const [naziv12, setNaziv12] = useState('');
    const [naziv22, setNaziv22] = useState('');
    const [mjesto, setMjesto] = useState('');
    const [mjesto2, setMjesto2] = useState('');
    const [ulica, setUlica] = useState('');
    const [ulica2, setUlica2] = useState('');
    const [kbr, setKbr] = useState('');
    const [kbr2, setKbr2] = useState('');
    const [ptt, setPtt] = useState('');
    const [ptt2, setPtt2] = useState('');
    const [tip, setTip] = useState('');
    const [tip2, setTip2] = useState('');
    const [tip3, setTip3] = useState('');
    const [tip12, setTip12] = useState('');
    const [tip22, setTip22] = useState('');
    const [tip32, setTip32] = useState('');
    const [datum_mobile, setDatumMobile] = useState('');
    const [datum_mobile2, setDatumMobile2] = useState('');
    const [datumVal, setDatumVal] = useState('');
    const [datumVal2, setDatumVal2] = useState('');
    const [operator, setOperator] = useState('');
    const [akcija, setAkcija] = useState('');
    const [isObjava, setIsObjava] = useState(false);

    const [name, setName] = useState('');
    const [name2, setName2] = useState('');
    const [surname, setSurname] = useState('');
    const [surname2, setSurname2] = useState('');

 


    const [rucnoNaziv1, setRucnoNaziv1] = useState('');
    const [rucnoNaziv2, setRucnoNaziv2] = useState('');
    const [rucnoMjesto, setRucnoMjesto] = useState('');
    const [rucnoUlica, setRucnoUlica] = useState('');
    const [rucnoKBR, setRucnoKBR] = useState('');
    const [rucnoKBRDodatak, setRucnoKBRDodatak] = useState('');
    const [selectedRucnoTip, setSelectedRucnoTip] = useState(3);

    const [rucneKorekcije, setRucneKorekcije] = useState(true);

    const [tkOperatorRow, setTkOperatorRow] = useState('');
    const [tkOperatorRowID, setTkOperatorRowID] = useState('');
    const [akcijaRow, setAkcijaRow] = useState('');
    const [changingTKC, setChangingTKC] = useState(false);

    const [activeTKCRow, setActiveTKCRow] = useState('');
    

    const [chosenTKCRow, setChosenTKCRow] = useState('');


    const [flagChangeName, setFlagChangeName] = useState(false);


    const [listOfPozivni, setListOfPozivni] = useState([]);
    


    const korisnik = useSelector((state) =>state.korisnik ? state.korisnik.value : "" )



    const tkc = JSON.parse(localStorage.getItem("tkc"));

    const [poziv, setPoziv] = useState(JSON.parse(useLocalStorage.getItem("tkc")));

    const tkc2 = useSelector((state) =>state.TKC ? state.TKC.value : {tkc: "", pozivni: ""} )
    //const tkc2 = useSelector((state) =>state.tkc)

   

    const [pojavljivanjeIsOpen, setPojavljivanjeIsOpen] = useState(false)
    const [selectedCell, setSelectedCell] = useState()



    const togglingValue = useSelector((state) => state.togglingVariable?state.togglingVariable.value: 0);
    const isMenuOpen = useSelector(store=>store.menu?store.menu.open:false)

    const [changeOwner, setChangeOwner] = useState(false);

    const toastError = {                                                        
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
   };

   const toastSuccess = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };

   const toastInfo = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };
   



useEffect(() => {
        

        let tmp = new Date();

        tmp.setMinutes(tmp.getMinutes() - 25);


        let timeNow = tmp.getDate() + "." + (tmp.getMonth() + 1) + "." + " " + tmp.getHours() + ":" + tmp.getMinutes();

        setCurrTime(timeNow);

        getUsers () 


}, []);

useEffect(()=>{
        document.title="Admin dnevnik"
},[])


    const [showUsers, setShowUsers] = useState(false);
    const [users, setUsers] = useState([],[]);

   
    const [operatori, setOperatori] = useState([]);



    const [currOper, setCurrOper] = useState({});


    const [errors, setErrors] = useState([]);

    const [currError, setCurrError] = useState({});

    //const [callingCodes, setCallingCodes] = useState([{naziv:'1', id:'1'},{naziv:'20', id:'2'},{naziv:'21', id:'3'}]);
    const [callingCodes, setCallingCodes] = useState([]);

    const [currCallingCode, setCurrCallingCode] = useState({});

    const [checked, setChecked] = useState(false);

    const [doneCheck, setDoneCheck] = useState(0);

    const [chosenDate, setChosenDate] = useState('');

    



async function getUsers () {


    dispatch(actions.isLoading());


    APICall(
    
        '/GetDailyUsersVal',
        
        {

                platform: '0',
                version:'1.0',

            },
        {
            token
        }).then(


            (response) => {
                
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());
            
                            if(response.data.list && response.data.list.length!=0){
                                    var dataTmp = response.data;

                                    console.log("/*********************************************************************/");
                                    console.log(dataTmp.list[0]);
                                    console.log("/*********************************************************************/");

                                    

                                    let i = 0;

                                    let columns= Object.getOwnPropertyNames(dataTmp.list[0]).map((column,index)=>{
                                        var a = column.charAt(0).toUpperCase() + column.slice(1);
                                      
                                        let widthC = 100;
                                        switch(column) {
                                            case "val_name":
                                                widthC = 200;
                                                break;
                                            
                                            default:
                                                // code block
                                            } 
                                        
                                        return(
                                            {
                                                "field": column,
                                                "getRowId": index,
                                                "width": widthC

                                            
                                            }
                                        )
                                    })



                                    
                                    let rows =dataTmp.list.map((item, index)=> {
                                        return({...item,id:index})
                                    })

                                    setUsers({
                                            columns,
                                            rows
                                    })

                                    setShowUsers(true);


                                    setFilteredTableData([],[]);
                        
                                    
                                    setSelectedCell(null)

                                    setSelectedItemsUsers([]);

                                    console.log("Selected items: ");
                                    console.log(selectedItemsUsers);

    
                                    setName(false);
                                    setAdmin(false);
                                    setSeeDaily(false);
                                    setEditDaily(false);
                                    setSeeStatRef(false);
                                    setSeeStatRefAll(false);
                                    setSeeStatTK(false);
                                    setAdminTK(false);
                                    setAdminData(false);
                                
                                    setAdminUsers(false);
    
                                   
                                        
                                    }else{

        

                                    setUsers([],[])

                                

                                    }
            
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
                setUsers([],[]);


            
                        if(!error.response){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            


                        } else {


                                if(!error.response.status){

                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);

                                }else{

                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                    
                                
                                    } else {
                                
                                
                                            toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                        }
                    
                    
            
            
            });

            
            
}      




const obrisiOdabrano=() => {


    if(selectedItemsUsers && selectedItemsUsers.length && selectedItemsUsers.length > 1){

        console.log("Puno ih je!!!");

        console.log(selectedItemsUsers.length);
        console.log(selectedItemsUsers)

        Swal.fire({
                title: `Jeste li sigurni da želite obrisati sve odabrane korisnike?`,
                text: "Ova radnja se ne može poništiti",
                icon: "warning",
                iconSize: '5',

                showCancelButton: true,
                confirmButtonColor: "#e31b2e",
                cancelButtonColor: "#29648a",
                showCancelButton: true,
                confirmButtonText: "Da, obriši!",
                cancelButtonText: "Odustani",
                reverseButtons: true
                }).then((result) => {
                if (result.isConfirmed) {

                        deleteUsers();

                }
                });
            

    } else {

        if(selectedItemsUsers && selectedItemsUsers.length && selectedItemsUsers.length == 1){


                console.log("Samoj je jedan!!!");
                console.log(selectedItemsUsers.length);
                console.log(selectedItemsUsers)

                Swal.fire({
                        title: `Jeste li sigurni da želite obrisati odabranog korisnika?`,
                        text: "Ova radnja se ne može poništiti",
                        icon: "warning",
                        iconSize: '5',

                        showCancelButton: true,
                        confirmButtonColor: "#e31b2e",
                        cancelButtonColor: "#29648a",
                        showCancelButton: true,
                        confirmButtonText: "Da, obriši!",
                        cancelButtonText: "Odustani",
                        reverseButtons: true
                        }).then((result) => {
                        if (result.isConfirmed) {

                                deleteUsers();

                        }
                        });

        } else {


            toast.error("Morate odabrati barem jednog korisnika za brisanje", toastError)

        }


    }

 
    
};
    


async function deleteUsers () {


    dispatch(actions.isLoading());

    console.log(selectedItemsUsers.length);

    
    APICall(
        '/DeleteUsersVal',
        
        {

             platform: '0',
             version:'1.0',
             selected: selectedItemsUsers,

         },
        {
            token
        }).then(


            (response) => {
               
                dispatch(actions.isNotLoading());

                setSelectedItemsUsers([]);

                if(response==undefined) dispatch(actions.isNotLoading());
            
                if(response.status==200){
                        
                    toast.success(response.data.message, toastSuccess);

                    setSelectedItemsUsers([]);

                    getUsers();
                

                } else {

                    if(response.status == 401){

                            console.log("Istekla sesija");
    
                            toast.error(response.data.message, toastError);
                            
                            dispatch(actions.logOut());
                            navigate('/');

                    } else {
                            toast.error(response.data.message,
                                toastError);
                                                

                    }
  
               
                }        
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
            


            
                        if(!error.response){

                             toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);
                          


                        } else {


                             if(!error.response.status){

                                  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);

                             }else{

                                  if (error.response.status == 401) {
              
                           
                                       toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                  
                             
                                  } else {
                             
                             
                                            toast.error(error.response.data.message,
                                                 toastError);
                                                                           
                                       
                                  }
                             }
                        }
                    
                   
            
            
            });

            
            
}      


async function saveUserChange () {


    dispatch(actions.isLoading());



    
    APICall(
        '/editUsers',
        
        {

             platform: '0',
             version:'1.0',
             val_id: valID,
             val_name: val_ime,
             admin: admin,
             seeDaily: seeDaily,
             editDaily: editDaily,
             seeStatRef: seeStatRef,
             seeStatRefAll: seeStatRefAll,
             seeStatTK: seeStatTK,
             adminTK: adminTK,
             adminData: adminData,
             adminUsers: adminUsers

             

         },
        {
            token
        }).then(


            (response) => {
               
                dispatch(actions.isNotLoading());

                setSelectedItemsUsers([]);

                if(response==undefined) dispatch(actions.isNotLoading());
            
                if(response.status==200){
                        
                    toast.success(response.data.message, toastSuccess);

                    setSelectedItemsUsers([]);

                    setAdmin(false);
                    setSeeDaily(false);
                    
                    setEditDaily(false);
                    setSeeStatRef(false);
                    setSeeStatRefAll(false);
                    setSeeStatTK(false);
                    setAdminData(false);
                    setAdminUsers(false);
                    setAdminTK(false);

                    setValID('');
                    setValIme('');
                    setValUsername('')

                  

                    getUsers(currOper, currError, currCallingCode, doneCheck, chosenDate);
                

                } else {

                    if(response.status == 401){

                            console.log("Istekla sesija");
    
                            toast.error(response.data.message, toastError);
                            
                            dispatch(actions.logOut());
                            navigate('/');

                    } else {
                            toast.error(response.data.message,
                                toastError);

                            
                                                

                    }
  
               
                }        
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
            


            
                        if(!error.response){

                             toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);
                          


                        } else {


                             if(!error.response.status){

                                  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);

                             }else{

                                  if (error.response.status == 401) {
              
                           
                                       toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                  
                             
                                  } else {
                             
                             
                                            toast.error(error.response.data.message,
                                                 toastError);
                                                                           
                                       
                                  }
                             }
                        }
                    
                   
            
            
            });

            
            
}      




const customLocaleText = {
    // Filter panel
    filterPanelAddFilter: 'Dodajte filter',
    filterPanelDeleteIconLabel: 'Ukloniti',
    filterPanelOperators: 'Operatori',
    filterPanelOperatorAnd: 'I',
    filterPanelOperatorOr: 'Ili',
    filterPanelColumns: 'Stupci',
    filterPanelInputLabel: 'Spremi',
  
    // Toolbar
    toolbarColumns: 'Stupci',
    toolbarFilters: 'Filteri',
    toolbarDensity: 'Gustoća',
    toolbarExport: 'Eksport',
    
    // Column menu
    columnMenuSortAsc: 'Uzlazno sortiranje',
    columnMenuSortDesc: 'Silazno sortiranje',
    columnMenuFilter: 'Filtrirati',
    columnMenuHideColumn: 'Sakrij stupac',
    columnMenuUnsort: 'Ukloni sortiranje',

    toolbarQuickFilterPlaceholder: 'Traži...',
    toolbarQuickFilterLabel: 'Traži',
    toolbarQuickFilterDeleteIconLabel: 'Očisti',
      // Filter operators text
  filterOperatorContains: 'sadrži',
  filterOperatorDoesNotContain: 'ne sadrži',
  filterOperatorEquals: 'jednako',
  filterOperatorDoesNotEqual: 'nije jednako',
  filterOperatorStartsWith: 'počinje s',
  filterOperatorEndsWith: 'završava s',
  filterOperatorIs: 'je',
  filterOperatorNot: 'nije',
  filterOperatorAfter: 'je iza',
  filterOperatorOnOrAfter: 'je na ili iza',
  filterOperatorBefore: 'je prije',
  filterOperatorOnOrBefore: 'je na ili prije',
  filterOperatorIsEmpty: 'je prazno',
  filterOperatorIsNotEmpty: 'nije prazno',
  filterOperatorIsAnyOf: 'je među',
  'filterOperator=': '=',
  'filterOperator!=': '!=',
  'filterOperator>': '>',
  'filterOperator>=': '>=',
  'filterOperator<': '<',
  'filterOperator<=': '<=',

    // Column menu text
    columnMenuLabel: 'Izbornik',
    columnMenuShowColumns: 'Pokaži stupce',
    columnMenuManageColumns: 'Uredi stupce',
    columnMenuFilter: 'Filter',
    columnMenuHideColumn: 'Sakrij stupac',
    columnMenuUnsort: 'Ukloni sortiranje',
    columnMenuSortAsc: 'Sortiraj uzlazno',
    columnMenuSortDesc: 'Sortiraj silazno',

      // Columns management text
  columnsManagementSearchTitle: 'Traži',
  columnsManagementNoColumns: 'Nema stupaca',
  columnsManagementShowHideAllText: 'Prikaži/sakrij sve',
  columnsManagementReset: 'Resetiraj',

      // Checkbox selection text
  checkboxSelectionHeaderName: 'Odabir redaka',
  checkboxSelectionSelectAllRows: 'Odaberi sve retke',
  checkboxSelectionUnselectAllRows: 'Ukloni odabir',
  checkboxSelectionSelectRow: 'Odaberi redak',
  checkboxSelectionUnselectRow: 'Ukloni odabir retka',
  
    // Rows
    footerRowSelected: (count) => `${count} redaka odabrano`,
    noRowsLabel: 'Nije odabran nijedan redak',
  };

  const myEventHandler = (e) => {
    console.log("Opened contexxxxxxxt");
    console.log("yaaay");
}





const VISIBLE_FIELDS = ['Naziv', 'Telefon', 'Adresa'];

const apiRef = useGridApiRef();

return (
    <ThemeProvider theme={theme}>



        <div className="DPDonat-main-container">
        <div className={`DPDonat-header ${isMenuOpen ? "is-extended": ""}`}            
                onMouseEnter={()=> dispatch(actions.openMenu())}
                onMouseLeave={()=> dispatch(actions.closeMenu())}
            >

                <div className="DPDonat-header-changes-title">

                    <Typography className="DPDonat-header-changes-title-text" variant="h5">
                        Val - Neispravni podaci svih operatera
                    </Typography>

                </div>

            </div>
            <div className="DPDonat-body">
                <div className="BadData-data-display">

                <Grid container spacing={2}>



                        <Grid item xs={2}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="primary" disabled={showUsers}
                                        onClick={() => {
                                            
                                            getUsers();
                                            setShowUsers(true);
                                        }}
                                 
                                        >
                                        Prikaži podatke
                                    </Button>
                        </Grid>
                       
 
                        

                  


                        <Grid item xs={2}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="error" disabled={!showUsers}
                                        onClick={() => {

                                    
                                            setShowUsers(false);
                                            setFilteredTableData([],[]);
                                
                                            
                                            setSelectedCell(null)
        
            
                                            setTelefon('');
                                            setTelefon2('');
                                            setOperator('');
                                       
            
                                            setNaziv1('')
                                           
                                            setNaziv12('');
                                            
                                            setOIB('');
                                            setOIB2('');
            
            
            
                                            setMjesto('')
                                            setMjesto2('')
            
                                            setPtt('');
                                            setPtt2('');
            
                                            
                                            setUlica('');
                                            setUlica2('');
            
                                            
            
            
                                            
                                            setTip('');
                                            setTip12('');
                                            setTip2('');
                                            setTip22('');
                                            setTip3('');
                                            setTip32('');
            
            
            
            
            
                                            setDatumVal('');
            
            
                                            setName('');
                                            setSurname('');
                                            setName2('');
                                            setSurname2('')
            
            
                                            setObrnuto('  ');
                                            setObrnuto2('  ');
        
                                            setTkOperatorRow('');
                                            setAkcijaRow('');
        
                                            setActiveTKCRow('');
                                            setTkOperatorRowID('');
        
                                            setRucnoKBR('');
                                            setRucnoKBRDodatak('');
                                            setRucnoMjesto('');
                                            setRucnoUlica('');
                                            setRucnoNaziv1('');
                                            setRucnoNaziv2('');
                                            setSelectedRucnoTip(3);
                                            //setRucneKorekcije(false);

                                            setBureInfo('');
                                            

                                        }}
                                 
                                        >
                                        Kraj
                                    </Button>
                        </Grid>



                        </Grid>

                        <Grid container spacing={2} sx={{marginTop:'20px', marginBottom: '20px'}}>

 

                        <Grid item xs={4}>
                 
                                <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} 
                                color="info"
                                variant="contained" disabled={!showUsers}
                                        onClick={() => {
                                           
                                               
                                            //obrisiOdabrano();
                                        }}
                                 
                                        >
                                        Dodaj novog korisnika
                                </Button>
 
                        </Grid>

                        <Grid item xs={4}>
                 
                                <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} 
                                color="error"
                                variant="contained" disabled={!showUsers}
                                        onClick={() => {
                                           
                                               
                                            obrisiOdabrano();
                                        }}
                                 
                                        >
                                        Obriši odabrane korisnike
                                </Button>
 
                        </Grid>
                        <Grid item xs={2}>
                 

          
                        </Grid>

                        <Grid item xs={3}>

                        </Grid>

                        <Grid item xs={2}>
                        {/*<FormControlLabel required control={<Checkbox
                            
                            inputProps={{ 'aria-label': 'controlled' }}
                            onChange={(event) => {

                                    let tmp = 0;

                                    console.log("DoneCheck");
                                    console.log(doneCheck);

                                    if(doneCheck == 0){
                                         tmp = 1;
                                         setDoneCheck(1);
                                    } else {

                                        tmp = 0;
                                        setDoneCheck(0);
                                    }

                                    console.log(tmp);

                                    

                                    getUsers(currOper, currError, currCallingCode, tmp, chosenDate);
                            }}
                            />} label="Prikaži riješene" /> */}
                       
          
                        </Grid>   
                    </Grid>




                    <div className="DPDonat-data-display-table" style={{backgroundColor: togglingValue==1 ? "#eeeeee7a" : "white", display:showUsers? "flex":"none" }}>


                        {showUsers && users.rows &&  <div style={{ width: "100%", height: "100%" }}> <AgGridReact
                                rowData={users.rows}
                                columnDefs={users.columns}

                        

                               
                                ref={gridRef}
                                theme={themeAG}
                              
                                autoSizeStrategy={autoSizeStrategy}
                                onGridReady={onGridReady}
                                onColumnResized={onColumnResized}

                         
                                onRowSelected={onRowSelected}
                                onSelectionChanged={onSelectionChanged}

                                

                                selectAll={selectAll}


                                rowSelection="multiple"
                   
                                onRowClicked={cellClicked}


                        /></div> } 

    
                    </div>



               



                    <div className="BijeleStranice-form-third-part">
                        <Grid sx={{padding:'5px', gap:"0px"}} container spacing={0.75} columns={{xs:12}}>

                            <Grid xs={12} sx={{padding:'5px', gap:"0px"}} container spacing={0.75} columns={{xs:12}}>
                                                            <Grid xs={7}>
                                                               <TextField
                                                                    InputProps={{sx:{height:30}}}
                                                                    InputLabelProps={{
                                                                        sx: {
                                                                            
                                                                            fontSize: "10px",
                                                                            
                                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                        }
                                                                        }}
                                                                                                size="small"
                                                                                                fullWidth
                                                                                                id=""
                                                                                                label="Ime"
                                                                                                value={val_ime}
                                                                                                variant="outlined"
                                                                                                
                                                                                                
                                                                                                onChange={(event) => {
                                                                                                    setValIme(event.target);
                                                                                                }}
                                                                />
                                                            </Grid>

                                                            <Grid xs={5}>
                                                               <TextField
                                                                    InputProps={{sx:{height:30}}}
                                                                    InputLabelProps={{
                                                                        sx: {
                                                                            
                                                                            fontSize: "10px",
                                                                            
                                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                        }
                                                                        }}
                                                                                                size="small"
                                                                                                fullWidth
                                                                                                id=""
                                                                                                label="Korisničko ime"
                                                                                                value={val_username}
                                                                                                variant="outlined"
                                                                                                
                                                                                                onChange={(event) => {
                                                                                                    setValUsername(event.target);
                                                                                                }}
                                                                />
                                                            </Grid>


                                                            <Grid xs={4} sx={{display:"flex", flexDirection:'column', alignItems:"flex-start", 
                                                                justifyContent:"center", marginTop: '20px', marginBottom:'20px'}}>                                                           
                                                                <Grid xs={3} sx={{display:"flex", alignItems:"flex-start", 
                                                                    justifyContent:"center"}}>
                                                                        <FormControlLabel control={<Checkbox 
                                                                            checked={seeDaily} size="small"  
                                                                            onChange={(e)=>{
                                                                                        
                                                                                            setSeeDaily(!seeDaily);  


                                                                        }}/>} label="- Pregled dnevnih podataka" /> 
                                                  
                                                                </Grid>
                                                                <Grid xs={3} sx={{display:"flex", alignItems:"flex-start", 
                                                                        justifyContent:"center"}}>
                                                                            <FormControlLabel control={<Checkbox size="small" 
                                                                            checked={editDaily} 
                                                                            onClick={()=>{
                                                                                            
                                                                                                setEditDaily(!editDaily);  


                                                                            }}/>} label="- Obrada i uređivanje dnevnih podataka" /> 

                                                                </Grid>
                                                                <Grid xs={3} sx={{display:"flex", alignItems:"flex-start", 
                                                                    justifyContent:"center"}}>
                                                                        <FormControlLabel control={<Checkbox size="small" 
                                                                        checked={adminTK} 
                                                                        onClick={()=>{
                                                                                        
                                                                                            setAdminTK(!adminTK);  


                                                                        }}/>} label="- Pregled i uređivanje telekom podataka" /> 

                                                                </Grid>                                                            
                                                            </Grid> 

                                                            <Grid xs={4} sx={{display:"flex", flexDirection:'column', alignItems:"flex-start", 
                                                                justifyContent:"center", marginTop: '20px', marginBottom:'20px'}}>                                                           

                                                                <Grid xs={3} sx={{display:"flex", alignItems:"flex-start", 
                                                                        justifyContent:"center"}}>
                                                                            <FormControlLabel control={<Checkbox size="small" 
                                                                            checked={seeStatRef} 
                                                                            onClick={()=>{
                                                                                            
                                                                                         setSeeStatRef(!seeStatRef);        


                                                                            }}/>} label="- Pregled vlastite statistike" /> 

                                                                </Grid>                                                                    
                                                                <Grid xs={3} sx={{display:"flex", alignItems:"flex-start", 
                                                                        justifyContent:"center"}}>
                                                                            <FormControlLabel control={<Checkbox size="small" 
                                                                            checked={seeStatRefAll} 
                                                                            onClick={()=>{
                                                                                            
                                                                                        
                                                                                        
                                                                                        setSeeStatRefAll(!seeStatRefAll); 


                                                                            }}/>} label="- Pregled statistike drugih referenata" /> 

                                                                </Grid>
                                                                <Grid xs={3} sx={{display:"flex", alignItems:"flex-start", 
                                                                        justifyContent:"center"}}>
                                                                            <FormControlLabel control={<Checkbox size="small" 
                                                                            checked={seeStatTK} 
                                                                            onClick={()=>{
                                                                                            
                                                                                         setSeeStatTK(!seeStatTK);        


                                                                            }}/>} label="- Pregled statistike po operaterima" /> 

                                                                </Grid>                                                                
                                                            </Grid>                                                             
                                                                
                                                           
                                                            <Grid xs={4} sx={{display:"flex", flexDirection:'column', alignItems:"flex-start", 
                                                                justifyContent:"center", marginTop: '20px', marginBottom:'20px'}}>                                                           

                                                                 
                                                                <Grid xs={3} sx={{display:"flex", alignItems:"flex-start", 
                                                                        justifyContent:"center"}}>
                                                                            <FormControlLabel control={<Checkbox size="small" 
                                                                            checked={adminData} 
                                                                            onClick={()=>{
                                                                                            
                                                                                        setAdminData(!adminData);        


                                                                            }}/>} label="- Brisanje dolaznih datoteka" /> 

                                                                </Grid>
                                                                <Grid xs={3} sx={{display:"flex", alignItems:"flex-start", 
                                                                        justifyContent:"center"}}>
                                                                            <FormControlLabel control={<Checkbox size="small" 
                                                                            checked={adminUsers} 
                                                                            onClick={()=>{
                                                                                            
                                                                                         setAdminUsers(!adminUsers);         


                                                                            }}/>} label="- Pregled i uređivanje korisnika" /> 

                                                                </Grid>                                                                
                                                            </Grid>                                                                    
                                                            
                                                            <Grid xs={16} sx={{padding:'5px', gap:"0px"}} container spacing={0.75} columns={{xs:12}}>
                                                                    <Grid xs={3}>
                                                                                <Button sx={{height:"30px", fontSize:"10px"}} fullWidth variant="contained" 
                                                                                color="success" disabled={valID?false:true}
                                                                                        onClick={() => {
                                                                                
                                                                                                
                                                                                                saveUserChange();

                                                                                    }}>
                                                                                    Spremi promjene
                                                                                </Button>

                                                                    </Grid>           
                                                                    <Grid xs={3}>
                                                                                <Button sx={{height:"30px", fontSize:"10px", backgroundColor:'lightyellow', color:'black'}} fullWidth variant="contained" 
                                                                             
                                                                                        onClick={() => {
                                                  
                                                                                    }}>
                                                                                    Obriši lozinku
                                                                                </Button>

                                                                    </Grid>      
                                                                    <Grid xs={3}>
                                                                                <Button sx={{height:"30px", fontSize:"10px"}} 
                                                                                fullWidth variant="contained" color="info"
                                                                                        onClick={() => {
                                                                                          
                                                                                    }}>
                                                                                    Odustani
                                                                                </Button>

                                                                    </Grid>    

                                                                    <Grid xs={3}>
                                                                                <Button sx={{height:"30px", fontSize:"10px"}} fullWidth variant="contained" color="error"
                                                                                    onClick={() => {
                                                                                           
                                                                                    }}>
                                                                                    Obriši korisnika
                                                                                </Button>

                                                                    </Grid>          


 

                                                                

                                                                </Grid>  
                            </Grid>  

                        </Grid>  


                            
                    </div>                

  
            </div>

             </div>



        </div>
    </ThemeProvider >
  );
}

export default AdminDaily;